/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root";
import { Route as VersionsRouteImport } from "./routes/versions";
import { Route as CompareAiRouteImport } from "./routes/compare-ai";
import { Route as CompareRouteImport } from "./routes/compare";
import { Route as IndexRouteImport } from "./routes/index";

const VersionsRoute = VersionsRouteImport.update({
  id: "/versions",
  path: "/versions",
  getParentRoute: () => rootRouteImport,
} as any);
const CompareAiRoute = CompareAiRouteImport.update({
  id: "/compare-ai",
  path: "/compare-ai",
  getParentRoute: () => rootRouteImport,
} as any);
const CompareRoute = CompareRouteImport.update({
  id: "/compare",
  path: "/compare",
  getParentRoute: () => rootRouteImport,
} as any);
const IndexRoute = IndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => rootRouteImport,
} as any);

export interface FileRoutesByFullPath {
  "/": typeof IndexRoute;
  "/compare": typeof CompareRoute;
  "/compare-ai": typeof CompareAiRoute;
  "/versions": typeof VersionsRoute;
}
export interface FileRoutesByTo {
  "/": typeof IndexRoute;
  "/compare": typeof CompareRoute;
  "/compare-ai": typeof CompareAiRoute;
  "/versions": typeof VersionsRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  "/": typeof IndexRoute;
  "/compare": typeof CompareRoute;
  "/compare-ai": typeof CompareAiRoute;
  "/versions": typeof VersionsRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths: "/" | "/compare" | "/compare-ai" | "/versions";
  fileRoutesByTo: FileRoutesByTo;
  to: "/" | "/compare" | "/compare-ai" | "/versions";
  id: "__root__" | "/" | "/compare" | "/compare-ai" | "/versions";
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute;
  CompareRoute: typeof CompareRoute;
  CompareAiRoute: typeof CompareAiRoute;
  VersionsRoute: typeof VersionsRoute;
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/versions": {
      id: "/versions";
      path: "/versions";
      fullPath: "/versions";
      preLoaderRoute: typeof VersionsRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/compare-ai": {
      id: "/compare-ai";
      path: "/compare-ai";
      fullPath: "/compare-ai";
      preLoaderRoute: typeof CompareAiRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/compare": {
      id: "/compare";
      path: "/compare";
      fullPath: "/compare";
      preLoaderRoute: typeof CompareRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/": {
      id: "/";
      path: "/";
      fullPath: "/";
      preLoaderRoute: typeof IndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  CompareRoute: CompareRoute,
  CompareAiRoute: CompareAiRoute,
  VersionsRoute: VersionsRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
